/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './PreferencesDataRowValue.scss';

import classnames from 'classnames';
import { node, string } from 'prop-types';
import React from 'react';

const PreferencesDataRowValue = ({ children, className }) => (
  <div className={classnames('preferences-data-row-value', className)}>
    {children}
  </div>
);

PreferencesDataRowValue.propTypes = {
  children: node.isRequired,
  className: string
};

export default PreferencesDataRowValue;
